// =====================================================================================
// FILE: src/services/apiAdapter.js
// =====================================================================================

import {
  fetchFixtureItems,
  updateCueOrder,
  createOutOfGameRow,
  updateOutOfGameRow,
  deleteOutOfGameRow,
  clearOutOfGameRowAssets,
  fetchFixtureItemsInGame,
  updateCueOrderInGame,
  createInGameRow,
  updateInGameRow,
  deleteInGameRow,
  clearInGameRowAssets,
  fetchFixtureItemsIptv,
  updateCueOrderIptv,
  createIptvRow,
  updateIptvRow,
  deleteIptvRow,
  clearIptvRowAssets,
  fetchFixtureItemsLed,
  updateCueOrderLed,
  createLedRow,
  updateLedRow,
  deleteLedRow,
  clearLedRowAssets,
  fetchFixtureItemsTeam,
  updateCueOrderTeamList,
  createTeamListRow,
  updateTeamListRow,
  deleteTeamListRow,
  clearTeamListRowAssets,
  deleteMatchingOperatorRows,
} from "../airtable";

export function createApiAdapter(isInGame, isLed, isTeam, isIptv) {
  return {
    fetch: (fx, opts) => {
      if (isTeam) return fetchFixtureItemsTeam(fx, opts);
      if (isLed) return fetchFixtureItemsLed(fx, opts);
      if (isIptv) return fetchFixtureItemsIptv(fx, opts);
      return isInGame ? fetchFixtureItemsInGame(fx, opts) : fetchFixtureItems(fx, opts);
    },
    create: (payload) => {
      if (isTeam) return createTeamListRow(payload);
      if (isLed) return createLedRow(payload);
      if (isIptv) return createIptvRow(payload);
      return isInGame ? createInGameRow(payload) : createOutOfGameRow(payload);
    },
    update: (id, payload) => {
      if (isTeam) return updateTeamListRow(id, payload);
      if (isLed) return updateLedRow(id, payload);
      if (isIptv) return updateIptvRow(id, payload);
      return isInGame ? updateInGameRow(id, payload) : updateOutOfGameRow(id, payload);
    },
    del: (id) => {
      if (isTeam) return deleteTeamListRow(id);
      if (isLed) return deleteLedRow(id);
      if (isIptv) return deleteIptvRow(id);
      return isInGame ? deleteInGameRow(id) : deleteOutOfGameRow(id);
    },
    // ✅ Clear all linked asset fields on a row (triggers Airtable automation
    //    to remove orphaned operator view records before the row is deleted)
    clearAssets: (id) => {
      if (isTeam) return clearTeamListRowAssets(id);
      if (isLed) return clearLedRowAssets(id);
      if (isIptv) return clearIptvRowAssets(id);
      return isInGame ? clearInGameRowAssets(id) : clearOutOfGameRowAssets(id);
    },
    // ✅ Delete matching rows from CG Operator and Ribbon Operator tables
    //    by Name, to prevent orphaned/stale operator records
    deleteOperatorRows: (name) => deleteMatchingOperatorRows(name),
    updateCueOrder: (arr) => {
      if (isTeam) return updateCueOrderTeamList(arr);
      if (isLed) return updateCueOrderLed(arr);
      if (isIptv) return updateCueOrderIptv(arr);
      return isInGame ? updateCueOrderInGame(arr) : updateCueOrder(arr);
    },
  };
}
